import React from 'react';
import moment from 'moment';
import { EyeOutlined, FileTextOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { lpad } from '../../../utils/helper';

const Columns = (onDetailClick: (id: string) => void, onLogsClick: (id: string) => void) => {
    return [
        {
            title: 'ID',
            dataIndex: 'id',
            render: (value) => lpad(value, 5).toUpperCase(),
        },
        {
            title: 'Username',
            dataIndex: 'username',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            render: (value, record) => `${record.countryCode || ''}-${value || ''}`,
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            render: (value) => moment(value).format('MM/DD/YYYY'),
        },
        {
            title: 'Actions',
            dataIndex: 'id',
            render: (id) => (
                <div className={'action-button'}>
                    <div>
                        <Tooltip title="View user transactions">
                            <EyeOutlined onClick={() => onDetailClick?.(id)} />
                        </Tooltip>
                    </div>
                    <div>
                        <Tooltip title="View user logs">
                            <FileTextOutlined onClick={() => onLogsClick?.(id)} />
                        </Tooltip>
                    </div>
                </div>
            ),
        },
    ];
};
export { Columns };
